import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';

export function highlightsSlideshow(opts = {}) {
  let splide = null;
  let splideEl = null;

  return {
    init() {
      splideEl = this.$refs.splideEl || this.$root;

      splide = new Splide(splideEl, {
        type: 'loop',
        autoScroll: {
          autoStart: false,
          speed: 0.5
        },
        intersection: {
          inView: {
            autoScroll: true,
          },
          outView: {
            autoScroll: false,
          },
        },
        autoWidth: true,
        padding: { left: '1rem', right: '1rem' },
        mediaQuery: 'min',
        breakpoints: {
          640: {
            padding: { left: '2.5rem', right: '2.5rem' },
          },
          1024: {
            autoScroll: {
              speed: 0.75
            },
            padding: { left: 'clamp(2.5rem,-3.35rem + 9.15vw,6.25rem)' }
          }
        },
      } );

      splide.mount({ AutoScroll, Intersection });
    }
  };
}
